import {
  GetTaskGroupTask,
  getTaskListByParas,
  getAllCurrentUserTask,
  GetTaskViewHistory,
  GetAllManageServerCenterByUserId,
  GetServerCenterByUserId,
  GetTaskLuneceQuery,
  GetAllTemplateByUserId,
  GetTaskListByTaskIdList,
  GetAllVisibleTemplateByUserId
} from "@/api/modules/basicData/task";
import {
  getToken
} from "../../util/auth";
import searchJs from "../../util/search";
import {
  listToTree,
  getParent,
  GetTemplateFaultTypeSearchResultByTemplateID
} from '@/api/modules/basicData/commonData'
import {
  GetTemplateUserSearchResultByTemplateID, GetTemplateHostSearchByTemplateID, GetPubHostListBySearchPamaWeb, GetTemplateTeamSearchByTemplateID
} from '@/api/modules/basicData/organization'
import CreateExecUsereObj  from "@/components/basicTemplate/SelectCreateExecUser/CreateExecUserHelper.js"
import ObjectInstanceID  from "@/components/basicTemplate/SelectDeviceObject/ObjectInstanceHelper.js"
import UserID  from "@/components/basicTemplate/SelectUser/UserHelper.js"
import {GetTemplateCreateExecUserSearchByTemplateID,GetTemplateDeviceObjectSearchByTemplateID} from "@/api/modules/basicData/baseTemplateInterface";
// let {methed:{transParam}} = a;
const cookieUser = getToken();
export default {
  state: {
    rowId: '',// 修改结果集模板是table当前行的id
    columns: [],
    isLookRecord: true,
    category: 0, // 当前使用模板组件的类型
    tableData: [], // 编辑结果集页面的列表
    isExpand: false, // 判断是否展开右侧
    hhh: null, // tree的高亮显示
    lookRecordTree: [], // 浏览记录树
    draggableRow:{},//拖拽行数据
    allTemplate: [], // 所有模板
    allVisibleTem: [], //左侧展示的所有模板，--不是树结构
    rClick1: false,
    rClick2: false,
    rClick3: false,
    allLeftTree: [], // 左侧所有个人模板
    temporary: [], //所有模板 除分组
    dormitory: [], //模板管理里面的赋值
    temClass: [], // 所有分组
    treeDataLeft: [], // 左侧树结构  --个人
    pendingTaskList: [], // 等待处理的任务集合
    isAllTask: false, //是否查看所有任务
    seekOrTag: true,
    isDisabled: false,
    isDragArea: false,
    tagLength: 0, //模板长度
    tagType: true, //是否新增结果集
    tagItem: {},
    resultTagItem: {}, //当前选中的结果集
    userId: cookieUser.userId,
    account: cookieUser.account,
    realName: cookieUser.realName,
    KeyWord: '', //全文搜索关键字
    pageIndex: 1,
    pageSize: 30,
    totalCount: 0,
    type: 0, //检索类型0：普通检索 1：全文检索
    curTask: {},
    taskDetailShow: false,
    taskSource: [], //任务列表
    taskClassList: [], //结果集分类
    tabIndex: '0',
    ServerCenterIds: '',
    ServerCenterDatas: [],
    nowTagObg: {},
    realTimeObj: {},
    watchMore: 0,
    taskRow: {}, // 当前被点击任务信息
    searchCondition: [], // 搜索条件
    tempType: null
  },
  mutations: {
    draggableRow(state,row){
      state.draggableRow=row;
    },
    redactTemplate(state, val) { // 编辑模板
      console.log('编辑task:', val)
      if (val.TEMPTYPE == 1) { // 结果集
        state.rowId = 'ID';
        if (val.CATEGORY == 0) {  //任务
          GetTaskListByTaskIdList(val.CONTENT, state.userId).then(res => {
            state.tableData = res;
            state.rowId = 'ID';
          });
        } else if (val.CATEGORY == 9) {  //故障类型
          GetTemplateFaultTypeSearchResultByTemplateID(val.ID, state.userId).then(res => {
            state.tableData = res;
            state.rowId = 'Id';
          });
        } else if (val.CATEGORY == 4) {  //计算机
          GetTemplateHostSearchByTemplateID(val.ID, state.userId).then(res => {
            state.tableData = res;
            state.rowId = 'MAC';
          });
        }
        else if (val.CATEGORY == 12) {  //团队
          GetTemplateTeamSearchByTemplateID(val.ID).then(res => {
            state.tableData = res;
            state.rowId = 'TeamId';
          });
        }
        else if (val.CATEGORY == 14) {  //任务创建、执行对象
          GetTemplateCreateExecUserSearchByTemplateID(val.ID,cookieUser.userId).then(res => {
            //格式[{"ID":"1","Type":1,"CreateExecType":0},{"ID":"ed16704de6992b2d","Type":3,"CreateExecType":0}]
            res.forEach(s=>s.SpecialKey = new CreateExecUsereObj({ID:s.SocialId,Type:s.Type,CreateExecType:s.CreateExecType}));
            state.tableData = res;
            state.rowId = 'SpecialKey';
          });
        }
        else if(val.CATEGORY == 16){  //运维对象实例
          
          GetTemplateDeviceObjectSearchByTemplateID(val.ID,cookieUser.userId).then(res=>{
            
            res.forEach(s=>s.SpecialKey = new ObjectInstanceID({ID:s.SocialId,Type:s.Type}));
            state.tableData = res;
            state.rowId = 'SpecialKey';
          })
        }
        else if (val.CATEGORY == 6) {  //人员
          GetTemplateUserSearchResultByTemplateID(val.ID, state.userId).then(res => {
            res.forEach(s=>s.SpecialKey = new UserID({ID:s.ID,Type:s.Type}));
            state.tableData = res;
            state.rowId = 'SpecialKey';
          });
        } 
      } else { // 搜索模板
        let content = JSON.parse(val.CONTENT);
        if(val.CATEGORY == 0){
          this.commit('setQueryTask', content);
        }
      }
    },
    getAllTemplate(state) {
      GetAllVisibleTemplateByUserId(state.userId, state.category).then((data) => { //获取左侧所有模板
        // data.forEach((c) => {
        // 	if (c.TEMPTYPE != 2 && !c.PID) {
        // 		c.PID = 'zzz'
        // 	}
        // })
        let temClass = [];
        data.forEach((c) => {
          if (c.TEMPTYPE == 2 || c.TEMPTYPE == 4) {
            temClass.push(c)
          }
        })
        state.temClass = temClass;
        let arr = [];
        state.allVisibleTem = data;

        let lookRecordTree = [{
          ICON: "任务一览.png",
          ROLETYPE: 0,
          TEMPTYPE: 2,
          VISIBLE: true,
          CONTENT: '',
          ID: '',
          NAME: '浏览记录',
          ISDEFAULT: false,
        }];

        data.forEach((c) => {
          if (c.NAME !== '浏览记录') {
            arr.push(c)
          } else {
            lookRecordTree = [];
            lookRecordTree.push(c)
          }
        })

        arr = arr.filter(item=>item.TEMPTYPE!=5 && item.TEMPTYPE!=6);

        lookRecordTree.forEach((z) => {
          z.label = z.NAME;
          z.id = z.ID;
        })
        arr.forEach((c) => {
          c.label = c.NAME;
          c.id = c.ID;
        })
        let indexArr = [];
        state.lookRecordTree = lookRecordTree;
        indexArr = listToTree('ID', 'PID', arr);
        console.log(indexArr, 'indexArr')
        indexArr.sort(function (a, b) {
          return b.ORDERINDEX > a.ORDERINDEX ? -1 : 1;
        });
        indexArr.forEach(val => {
          if (val.children) {
            val.children.sort(function (a, b) {
              return b.ORDERINDEX > a.ORDERINDEX ? -1 : 1;
            });
          }

        })
        state.treeDataLeft = indexArr
        console.log(indexArr, '-------------')
      })
    },
    setIsCheckbox(state, isCheckbox) {
      state.isCheckbox = isCheckbox;
    }
  },
  actions: {

  }
}
